import axios from "../axios";
import { storeViralitySettingsURL } from "../requests";
export const getStoreViralitySettingsApi = (token: string) => {
  return axios.get(storeViralitySettingsURL, {
    headers: {
      token,
    },
  });
};
